import React from "react";
import Icon from "../../../../../stories/core-components/IconsSelector";
import * as S from "./ListingLoadingStyle";

const ListingLoadingUI = (props) => {
  return (
    <S.LoadingWrapper>
      <S.LoadingCar>
        <div className="carCont">
          <div className="iconCont">
            <Icon name="CabIconNoresults" styleProps={{margin: '0 0 -10rem 0'}}/>
          </div>
        </div>
        <p>{props?.loadingText || "LOADING CARS..."}</p>
      </S.LoadingCar>
    </S.LoadingWrapper>
  );
};

export default ListingLoadingUI;
